function handleCartPrice(){
  let subtotalCart = document.querySelector(
    ".cart-footer .cart-recap .docapp-right span[data-est-total] span[data-geolizr-price]"
  );
  let subtotalMiniCart = document.querySelector(
    ".docapp-right span[data-est-total] span[data-geolizr-price]"
  );

  if (subtotalMiniCart || subtotalCart) {
    clearInterval(interval);
    let element = subtotalCart || subtotalMiniCart;
    element.setAttribute("bss-b2b-cart-total-price", "");
    element.setAttribute("bss-b2b-cart-price-active", "true");
    BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
  }
}

let counter = 0;
const selector = ".cart-footer .cart-recap .docapp-right span[data-est-total] span[data-geolizr-price], .docapp-right span[data-est-total] span[data-geolizr-price]";
const interval = setInterval(() => {
  if (document.querySelector(selector)) {
    handleCartPrice();
    clearInterval(interval);
  } else {
    counter += 100;
    if (counter >= 10000) {
      clearInterval(interval);
    }
  }
}, 100);

setTimeout(() => {
  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.target.className === 'cart-drawer__footer') {
        setTimeout(()=>{
            handleCartPrice();
        },1800)
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}, 300);


const intervalId = setInterval(() => {
  if (BSS_B2B?.shopData?.customer?.id === null) {
    const rows = document.querySelectorAll('.bss-b2b-qty-table-row');

    if (rows.length > 0) {
      const lastRow = rows[rows.length - 1];

      if (lastRow) {
        const qbElement = lastRow.querySelector('.border-radius-right-table-qb');

        if (qbElement) {
          const link = document.createElement('a');
          link.href = "https://7thearthstudios.com/pages/lead-gen-wholesale";
          link.textContent = "Sign up for wholesale to unlock";
          link.style.color = "blue";
          link.style.cursor = "pointer";
          link.addEventListener('click', (e) => {
            e.stopPropagation();
          });

          qbElement.innerHTML = "";
          qbElement.appendChild(link);

          clearInterval(intervalId); 
        }
      }
    }
  } else {
    clearInterval(intervalId);
  }
}, 500);

setTimeout(() => {
  clearInterval(intervalId);
}, 5000);
